import { css } from '@emotion/core'
import { Flow, Text, Theme, useTheme } from 'bold-ui'
import { MchatAplicacao, MChatPerguntaEnum, MChatRiscoEnum } from 'graphql/types.generated'
import HistoricoDetailTable from 'view/atendimentos/detail/historico/components/table/HistoricoDetailTable'
import { MCHAT_PERGUNTAS } from 'view/atendimentos/detail/soap/objetivo/puericultura/mchat-rf/mchat/model-mchat'
import { PERGUNTAS_RISCO_SIM } from 'view/atendimentos/detail/soap/objetivo/puericultura/mchat-rf/mchat/utils-mchat'
import {
  MCHAT_RESULTADOS,
  MchatRfAplicacaoQueryModel,
} from 'view/atendimentos/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMChatResultado } from './HistoricoMChatResultado'

interface HistoricoMChatTableBoxProps {
  risco: MChatRiscoEnum | null
  pontuacao: number
  aplicacao?: ReadonlyArray<MchatRfAplicacaoQueryModel>
  cidadaoIdadeEmMeses: number | undefined
}

export function HistoricoMChatTableBox(props: Readonly<HistoricoMChatTableBoxProps>) {
  const { risco, pontuacao, aplicacao, cidadaoIdadeEmMeses } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  if (risco === null) return null

  const { title, encaminhamento, colorScale } = MCHAT_RESULTADOS[risco]

  const hasAplicacao = aplicacao && aplicacao.length > 0

  return (
    <HistoricoDetailTable title='M-CHAT-R™' hasLines>
      {hasAplicacao && (
        <Flow direction='vertical' justifyItems='stretch' gap={0}>
          <Flow direction='horizontal' justifyContent='space-between' alignItems='center'>
            <Text fontWeight='bold'>Pergunta</Text>
            <Flow direction='horizontal' gap={0}>
              <Text fontWeight='bold' style={styles.rightColumns}>
                Resposta
              </Text>
              <Text fontWeight='bold' style={styles.rightColumns}>
                Pontuação
              </Text>
            </Flow>
          </Flow>
          {aplicacao.map((itemAplicacao: MchatAplicacao, index: number) => (
            <Flow direction='horizontal' key={itemAplicacao.id} justifyContent='space-between' alignItems='center'>
              <Flow direction='horizontal' gap={0.2} style={styles.perguntaBox} justifyItems='stretch'>
                <Text style={styles.perguntaOrdinal}>{index + 1}.</Text>
                <Text>{MCHAT_PERGUNTAS[itemAplicacao.pergunta]}</Text>
              </Flow>
              <Flow direction='horizontal' gap={0}>
                <Text fontWeight='bold' style={styles.rightColumns}>
                  {(PERGUNTAS_RISCO_SIM.includes(MChatPerguntaEnum[itemAplicacao.pergunta]) &&
                    itemAplicacao.stPassou) ||
                  (!PERGUNTAS_RISCO_SIM.includes(MChatPerguntaEnum[itemAplicacao.pergunta]) && !itemAplicacao.stPassou)
                    ? 'Não'
                    : 'Sim'}
                </Text>
                <Text fontWeight='bold' style={styles.rightColumns}>
                  {itemAplicacao.stPassou ? 0 : 1}
                </Text>
              </Flow>
            </Flow>
          ))}
          <Flow direction='horizontal' justifyContent='flex-end' gap={0} justifyItems='stretch'>
            <Text fontWeight='bold' style={styles.rightColumns}>
              Total de pontos
            </Text>
            <Text fontWeight='bold' style={styles.rightColumns}>
              {pontuacao}
            </Text>
          </Flow>
        </Flow>
      )}
      <div css={styles.resultadoSection}>
        <HistoricoMChatResultado
          title={title}
          titleColor={colorScale.c40}
          encaminhamento={encaminhamento(cidadaoIdadeEmMeses)}
          label={'ponto'.pluralizeAndConcatValue(pontuacao)}
        />
      </div>
    </HistoricoDetailTable>
  )
}

const createStyles = (theme: Theme) => ({
  rightColumns: css`
    width: 6rem;
    text-align: center;
  `,
  perguntaBox: css`
    grid-template-columns: 1.25rem auto;
  `,
  perguntaOrdinal: css`
    text-align: right;
  `,
  resultadoSection: css`
    & > div {
      border-top: 1px solid ${theme.pallete.divider};
    }
  `,
})
